import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Col,
  Row,
  Form,
  InputGroup,
  Overlay,
  Tooltip,
  FormControl,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import PagingNav from "../component/PagingNav";
import { getUserSession } from "../component/userInfo";
import Image from "react-bootstrap/Image";
import { useLocation, useParams } from "react-router";

import "./MybbsAdmin.css";
const ItemStatus = ({ item }) => {
  const [showTooltip, setShowTooltip] = useState();
  const target = useRef(null);

  console.log(item.status);
  return (
    <>
      {item.status === "발행예정" && (
        <>
          <span
            ref={target}
            onMouseOver={(event) => {
              setShowTooltip(true);
            }}
            onMouseOut={(event) => {
              setShowTooltip(false);
            }}
          >
            {item.status}
          </span>
          <Overlay
            target={target.current}
            show={showTooltip}
            placement="bottom"
          >
            {(props) => <Tooltip {...props}>{item.publish_time}</Tooltip>}
          </Overlay>
        </>
      )}
      {item.status === "발행중" && <span>{item.status}</span>}
      {item.status === "발행중지" && <span>{item.status}</span>}
    </>
  );
};
const DateOut = ({ item }) => {
  const [showTooltip, setShowTooltip] = useState();
  const target = useRef(null);

  const getMMDD = (dt) => {
    if (!dt) return "";
    return dt.substr(5, 5);
  };
  return (
    <>
      <>
        <span
          ref={target}
          onMouseOver={(event) => {
            setShowTooltip(true);
          }}
          onMouseOut={(event) => {
            setShowTooltip(false);
          }}
        >
          {getMMDD(item.idate)}
        </span>
        <Overlay target={target.current} show={showTooltip} placement="bottom">
          {(props) => <Tooltip {...props}>{item.idate}</Tooltip>}
        </Overlay>
      </>
    </>
  );
};

const MybbsAdmin = () => {
  const { mybbsId } = useParams();
  const location = useLocation();
  const tableInfo = location.state?.item;

  const [paging, setPaging] = useState();
  const [list, setList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [tno, setTno] = useState(tableInfo?.tno);
  const [page, setPage] = useState(location.state?.page || 1);

  const [bbsAdminTitle, setMybbsAdminTitle] = useState(
    tableInfo ? `[${tableInfo.title}]게시물관리` : `[${mybbsId}] 게시물관리`
  );
  // --- 조회 기능용 상태 변수 추가 ---
  const [perpage, setPerpage] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [tempKeyword, setTempKeyword] = useState("");

  useEffect(() => {
    if (mybbsId) {
      fetchList(page);
    }
  }, [mybbsId, page, keyword, perpage]);

  const fetchList = async (page) => {
    const userSession = getUserSession();
    try {
      const formData = new FormData();
      formData.append("uid", userSession.uid);
      formData.append("action", "list");
      formData.append("db", mybbsId);
      formData.append("perpage", perpage);
      if (page) formData.append("page", page);
      if (keyword) formData.append("keyword", keyword);
      formData.append("column", "all");

      let res = await fetch("https://work.wekoinonia.org/json/mybbsAdmin.php", {
        method: "POST",
        body: formData,
      });

      let json = await res.json();
      if (json.code && json.code !== "0000") {
        alert(json.msg);
        setList([]);
        setPaging(null);
        return;
      }

      if (json.paging) {
        setPaging(json.paging);
      }
      if (json.list) {
        setList(json.list);
      } else {
        setList([]);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("목록을 불러오는 중 오류가 발생했습니다.");
    }
  };

  const getPage = (newPage) => {
    setPage(newPage);
  };

  const handleSearch = () => {
    if (keyword !== tempKeyword) {
      setPage(1);
      setKeyword(tempKeyword);
    }
  };

  const handlePerpageChange = (e) => {
    setPage(1);
    setPerpage(parseInt(e.target.value, 10));
  };

  const selectItem = ({ target }) => {
    if (target.checked) {
      setSelectedList(selectedList.concat(target.value));
    } else {
      setSelectedList(selectedList.filter((selected) => selected !== target.value));
    }
  };

  const publishingClose = (e) => {
    if (selectedList.length <= 0) return;
    const userSession = getUserSession();
    try {
      const formData = new FormData();
      formData.append("uid", userSession.uid);
      formData.append("action", "close");
      formData.append("noList", selectedList.join());
      formData.append("noCount", selectedList.length);
      formData.append("db", mybbsId);

      fetch("https://work.wekoinonia.org/json/mybbsAdmin.php", {
        method: "POST",
        body: formData,
        mode: "cors",
      })
        .then((res) => res.json())
        .then((json) => {
          alert(json.msg);
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } catch (error) {
      console.log(error);
      alert(error.code + "\n" + error.message);
    }
  };

  const publishingRestore = (e) => {
    if (selectedList.length <= 0) return;
    const userSession = getUserSession();
    try {
      const formData = new FormData();
      formData.append("uid", userSession.uid);
      formData.append("action", "restore");
      formData.append("noList", selectedList.join());
      formData.append("noCount", selectedList.length);
      formData.append("db", mybbsId);

      fetch("https://work.wekoinonia.org/json/mybbsAdmin.php", {
        method: "POST",
        body: formData,
      })
        .then((res) => res.json())
        .then((json) => {
          alert(json.msg);
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } catch (error) {
      console.log(error);
      alert(error.code + "\n" + error.message);
    }
  };

  return (
    <div id="content">
      <div className="container-fluid">
        <h1 className="h3 mb-2 text-gray-800">{bbsAdminTitle}</h1>
        <p className="mb-4"></p>

        <div className="card shadow mb-4">
          <div className="card-body">
            <div>
              <div id="dataTable_wrapper" className="dataTables_wrapper dt-bootstrap4">
                <div className="dataTable-top">
                  <div className="dataTable-dropdown">
                    <label>
                      <select
                        className="dataTable-selector"
                        value={perpage}
                        onChange={handlePerpageChange}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="20">20</option>
                        <option value="25">25</option>
                      </select>
                    </label>
                  </div>
                  <div className="dataTable-search">
                    <InputGroup>
                      <FormControl
                        className="dataTable-input"
                        placeholder="제목,내용,작성자 조회"
                        value={tempKeyword}
                        onChange={(e) => setTempKeyword(e.target.value)}
                        onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                      />
                      <Button variant="primary" onClick={handleSearch}>
                        조회
                      </Button>
                    </InputGroup>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <table
                      className="table table-bordered dataTable"
                      id="dataTable"
                      width="100%"
                      cellSpacing="0"
                      role="grid"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr role="row">
                          <th style={{ width: "2rem" }}></th>
                          <th style={{ width: "auto" }}>No</th>
                          <th style={{ width: "auto" }}>제목</th>
                          <th style={{ width: "6rem" }}>작성자</th>
                          <th style={{ width: "4rem" }}>작성일</th>
                          <th style={{ width: "4rem" }}>상태</th>
                          <th style={{ width: "2rem" }}>댓글</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((item, index) => {
                          let textColor = item.use_yn === "Y" ? "text-body" : "text-muted";
                          return (
                            <tr key={index} className={textColor}>
                              <td>
                                <Form.Check
                                  aria-label={`option ${item.no}`}
                                  value={item.no}
                                  onChange={(e) => selectItem(e)}
                                />
                              </td>
                              <td>{item.no}</td>
                              <td>
                                <Link
                                  to={`/MybbsAdmin/${mybbsId}/view?bbsno=${item.no}`}
                                  state={{ item: tableInfo, page: page }}
                                >
                                  {item.title}
                                </Link>
                              </td>
                              <td>{item.name}</td>
                              <td>
                                <DateOut item={item} />
                              </td>
                              <td>{item.use_yn}</td>
                              <td>{item.recommend}</td>
                            </tr>
                          );
                        })}
                        {list.length === 0 && (
                          <tr>
                            <td colSpan="7"> 해당 데이터가 없습니다. </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <Row>
                  <Col lg={8} className="mx-auto">
                    <PagingNav paging={paging} callback={getPage} />
                  </Col>
                  <Col lg={4} className="mx-auto">
                    <InputGroup>
                      <Button
                        variant="danger"
                        type="button"
                        style={{ width: "8rem" }}
                        onClick={(e) => publishingClose(e)}
                      >
                        공개취소
                      </Button>
                      <Button
                        variant="primary"
                        type="button"
                        style={{ width: "8rem" }}
                        onClick={(e) => publishingRestore(e)}
                      >
                        공개복원
                      </Button>
                      <Link to={`/MybbsAdminView/${tno}`} style={{ display: "none" }}>
                        <Button
                          variant="primary"
                          type="button"
                          style={{ width: "8rem" }}
                        >
                          등록
                        </Button>
                      </Link>
                    </InputGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MybbsAdmin;